// extracted by mini-css-extract-plugin
export var body = "ModalFilters-module--body--478d1";
export var checkboxes = "ModalFilters-module--checkboxes--75f36";
export var filters = "ModalFilters-module--filters--4b510";
export var footer = "ModalFilters-module--footer--19c50";
export var hideModal = "ModalFilters-module--hide-modal--95cd5";
export var search = "ModalFilters-module--search--898c1";